const mode = process.env.NODE_ENV.trim()

let env = {
  mode,
  token: {
    name: 'ftk',
    refreshTokenName: 'frtk'
  },
  sns: {
    kakao: {
      appId: 'c85dcc5277165b74ea438446153d2bb8'
    },
    channeltalk: {
      // pluginKey: '7cf93209-c5fa-40fc-b28e-08c826fb7d2b',
      pluginKey: '02e8bc32-c02e-4e6d-a181-057653789c8b',
      guestIdName: 'fnchntgid',
      test: 4,
    }
  }
}

export default {
  namespaced: true,
  state: Object.assign(env, require(`./${mode}.js`).default)
}
